import { render, staticRenderFns } from "./CompensationSelection.vue?vue&type=template&id=53babf4b&scoped=true&class=h-100%20compensation-selection"
import script from "./CompensationSelection.vue?vue&type=script&lang=js"
export * from "./CompensationSelection.vue?vue&type=script&lang=js"
import style0 from "./CompensationSelection.vue?vue&type=style&index=0&id=53babf4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53babf4b",
  null
  
)

export default component.exports